module.exports = __webpack_public_path__ + "img/Container (5).f535436d.png";